import { SIZES } from "./withDelete";
const DELETE_BUTTON_COLUMN_WIDTH = SIZES.BUTTON_COLUMN_WIDTH;
export { default } from "./withDelete";
export { DELETE_BUTTON_COLUMN_WIDTH };
